import axios, { AxiosResponse } from "axios";

async function getPostsForYou(categories: number[], limit: number) {

    try {
        const res: AxiosResponse<any[]> = await axios.post(`${window.API_HOST}/api/for-you?categories=${categories.join(',')}&limit=${limit}`);

        return res.data
    } catch (err) {
        return [];
    }


}

export default getPostsForYou;